var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 32,
    viewBox: "0 0 85 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MSD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00827a",
    d: "M8.157 8.157c0-4.332 3.511-7.843 7.843-7.843s7.843 3.511 7.843 7.843zM8.157 23.843c0-4.332 3.511-7.843 7.843-7.843-4.332 0-7.843-3.511-7.843-7.843-4.332 0-7.843 3.511-7.843 7.843s3.511 7.843 7.843 7.843zM8.157 23.843c0 4.332 3.511 7.843 7.843 7.843s7.843-3.511 7.843-7.843zM16 16c4.332 0 7.843 3.511 7.843 7.843 4.332 0 7.843-3.511 7.843-7.843s-3.513-7.843-7.843-7.843c0 4.332-3.511 7.843-7.843 7.843z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f3e4a",
    d: "M51.456 8.157h4.861v15.684h-3.602v-10.549l-4.607 10.549-4.85-10.562v10.562h-3.361v-15.684h4.804l3.464 8.118zM69.131 12.788c0-3.098-2.381-4.899-5.229-4.899-2.823 0-5.902 1.653-5.902 4.865 0 2.785 3.066 4.216 4.815 4.668 0.961 0.254 3.386 0.525 3.386 2.258 0 1.648-1.695 2.097-2.963 2.097-1.634 0-2.594-1.145-2.453-2.874h-3.213c-0.112 3.902 2.54 5.356 5.638 5.426 3.581 0.082 6.315-1.448 6.315-4.897 0-3.467-3.102-4.014-5.526-4.8-0.94-0.305-2.679-0.576-2.679-2.176 0-1.34 1.156-1.981 2.339-1.981 1.522 0 2.311 0.753 2.425 2.317h3.047zM75.909 8.14h-4.997v15.671h4.997c4.156 0 8.37-2.4 8.37-7.82 0-5.424-4.216-7.851-8.37-7.851zM75.683 20.958l-1.384 0.004v-9.942h1.384c3.811 0 5.183 2.485 5.183 4.969s-1.374 4.969-5.183 4.969z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsd);
export default __webpack_public_path__ + "static/media/MSD.782c815900a3dd46a5c85602d8249f71.svg";
export { ForwardRef as ReactComponent };